document.addEventListener('click', function (event) {
  const toggle = event.target.closest('.js-insurance-show-more-toggle');
  if (!toggle) return;

  const cartItemKey = toggle.dataset.cartItemKey;
  const ctoCartItemKey = toggle.dataset.ctoCartItemKey;
  if (!cartItemKey && !ctoCartItemKey) return;

  const selectors = [];
  if (cartItemKey) selectors.push(`.js-insurance-collapsible-item[data-cart-item-key="${cartItemKey}"]`);
  if (ctoCartItemKey) selectors.push(`.js-insurance-collapsible-item[data-cto-cart-item-key="${ctoCartItemKey}"]`);

  const expanded = toggle.getAttribute('aria-expanded') === 'true';

  // The vendor theme forces `.cart_itemadd` display via !important rules at several
  // breakpoints (component-cart-drawer.css, custom-style.css). A plain inline style
  // (or jQuery's slideToggle, which also just writes a plain inline style) loses that
  // fight and the item can get stuck visible. Setting the inline style with !important
  // beats a stylesheet !important regardless of its specificity; removing the property
  // hands display back to the theme's own rules for the correct value per breakpoint.
  document.querySelectorAll(selectors.join(',')).forEach((row) => {
    if (expanded) {
      row.style.setProperty('display', 'none', 'important');
    } else {
      row.style.removeProperty('display');
    }
  });

  toggle.setAttribute('aria-expanded', String(!expanded));
  toggle.querySelectorAll('.js-insurance-show-more-label, .js-insurance-hide-label').forEach((label) => {
    label.classList.toggle('hidden');
  });
});
